import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Banner = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const sc = document.getElementById("sync");

    if (sc) {
      const ctx = sc.getContext("2d");
      sc.width = 336;
      sc.height = 100;

      let t = 0;
      let animationFrame;

      function draw() {
        ctx.clearRect(0, 0, 336, 100);

        ctx.beginPath();
        ctx.strokeStyle = "#FF6B6B";
        ctx.lineWidth = 2;

        for (let x = 0; x <= 336; x += 2) {
          const y =
            50 +
            Math.sin((x / 336) * Math.PI * 3 + t * 0.8) * 18 +
            Math.sin((x / 336) * Math.PI * 6 + t * 1.2) * 6;

          x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
        }

        ctx.stroke();

        const sync = 0.7 + 0.3 * Math.sin(t * 0.1);

        ctx.beginPath();
        ctx.strokeStyle = "rgba(45,58,140,0.6)";
        ctx.lineWidth = 1.5;

        for (let x = 0; x <= 336; x += 2) {
          const base =
            50 +
            Math.sin((x / 336) * Math.PI * 3 + t * 0.8) * 18 * sync +
            Math.sin((x / 336) * Math.PI * 6 + t * 1.2) * 6 * sync;

          const noise =
            (1 - sync) *
            Math.sin((x / 336) * Math.PI * 7 + t * 1.6) *
            8;

          const y = base + noise;

          x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
        }

        ctx.stroke();

        t += 0.04;
        animationFrame = requestAnimationFrame(draw);
      }

      draw();

      return () => cancelAnimationFrame(animationFrame);
    }
  }, []);

    return (
        <section className="banner">
            <div className="banner-blk">

                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="content-blk">

                                <div className="hero-eyebrow">
                                    <span claclassNamess="hero-dot"></span>
                                    <span className="overline">FutureSoulmates™ · Patent-Protected AI + DNA Platform</span>
                                </div>
                                <h1 className="disp-xl">
                                    Stop dating.
                                    <em className="coral">Start matching.</em>
                                </h1>
                                <p className="body-lg">
                                    One saliva DNA sample. Two answers: <strong>Are you compatible partners?</strong> And: <strong>Can you have healthy children together?</strong> Find your match in weeks, not years.
                                </p>
                                <div className="hero-btns">
                                    <button className="btn btn-coral">How It Works <span className="arr">→</span></button>
                                    <button className="btn btn-outline">Get Your DNA Kit</button>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-6">
                            <div className="hero-img-stack">
                                <img src="/images/banner.jpg" alt="" />
                                <div className="hero-img-badge">
                                    <div className="score-ring">
                                        <div>
                                            <span>94</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="badge-label">Compatibility</div>
                                        <div class="colortext">Excellent Match</div>
                                        <div>DNA + Psychometric + Biometric</div>
                                    </div>
                                </div>
                                <div className="sync-canvas-wrap">
                                    <div className="sync-label">bp_synchrony_score · Live</div>
                                    <canvas id="sync" width="336" height="100"></canvas>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >

    )
}

export default Banner
